import React from "react";

function _validatePath(path) {
  return path[0] === "/" ? path : `/${path}`;
}

function _createRoute(path, definitions, key, RouteComponent, props) {
  const redux = process.env.REDUX === true;
  const module = (definitions.component != "App"
    ? "/" + definitions.component
    : ""
  ).toLowerCase();
  const view = definitions.component != "App" ? "View" : "";
  const component = require(`../pages${module}/${definitions.component}${view}${
    redux ? "Container" : ""
  }`);

  const tmp = () => (
    <component.default {...props}/>
  );

  return (
    <RouteComponent
      exact={definitions.exact}
      key={key}
      path={_validatePath(path)}
      component={tmp}
    />
  );
}
export function generateRoutes(routeList, SwitchComponent, RouteComponent, props) {
  return (
    <SwitchComponent>
      {Object.keys(routeList).map((route, i) => {
        return _createRoute(route, routeList[route], `route_${i}`, RouteComponent, props);
      })}
    </SwitchComponent>
  );
}



// WEBPACK FOOTER //
// ./src/helpers/routing.js